/* eslint import/prefer-default-export: 0 */
import { NAME } from './types';

export const property = {
  getIsPending: state => state[NAME].isPending,
  getData: state => state[NAME].data,
  getError: state => state[NAME].error,
};
